import { defaultOpeningWidthFt } from 'utils/opening-drag';
import { openingBarRectOnRun } from 'utils/opening-layout';
import { runFrame } from 'utils/opening-position';
import {
  EdgeOpeningLayoutArgsType,
  EdgeOpeningLayoutType
} from 'utils/edge-opening-layout-types';

export function getEdgeOpeningLayout({
  item,
  edge,
  offsetFt,
  run,
  placement,
  zoom = 1,
  dragTransform
}: EdgeOpeningLayoutArgsType): EdgeOpeningLayoutType {
  const widthFt = item.width ?? defaultOpeningWidthFt(item.type);
  const rest = openingBarRectOnRun(run, offsetFt, widthFt);
  const liveRun = placement?.run ?? run;
  const live = placement
    ? openingBarRectOnRun(placement.run, placement.offsetFt, widthFt)
    : rest;
  const liveEdge = placement?.edge ?? edge;

  let translateX = 0;
  let translateY = 0;
  if (placement) {
    translateX = live.left - rest.left;
    translateY = live.top - rest.top;
  } else if (dragTransform) {
    translateX = dragTransform.x / zoom;
    translateY = dragTransform.y / zoom;
  }

  return {
    rest,
    live,
    liveEdge,
    liveRun,
    inwardSign: runFrame(liveRun).inwardSign,
    translateX,
    translateY
  };
}
